"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bs58_1 = require("bs58");
var SHA256 = require("crypto-js/sha256");
var BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
// var bs58 = require('base-x')(BASE58);
var basex = require("base-x");
var bs58 = basex(BASE58_ALPHABET);
// const BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
// import bs58 from 'base-x';
// const genBs58 = bs58(BASE58_ALPHABET);
exports.hexStringToByteArray = function (hexStr) {
    return new Uint8Array(hexStr.match(/[\da-f]{2}/gi).map(function (h) {
        return parseInt(h, 16);
    }));
};
exports.hexStringToBase58 = function (hexStr) {
    return bs58_1.encode(exports.hexStringToByteArray(hexStr));
};
exports.stringToSha256 = function (data) {
    return SHA256(data).toString();
};
exports.derToBase58 = function (der) {
    // console.log("1: ", encode(der))
    // console.log("2: ", bs58.encode(der))
    return bs58.encode(der); //encode(der);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/cryptography-ts/bin/utils.js
// module id = 38
// module chunks = 0 1